import React from 'react';

const YourLuckyNumbersSection = props => (
  <section className="your-lucky-numbers-section">
    {props.children}
  </section>
);

export default YourLuckyNumbersSection;
